export default class Style {
  constructor ({ logo = {}, background_type = 'color', background_color = null, background_image = {} } = {}) {
    this.logo = logo
    this.background_type = background_type
    this.background_color = background_color
    this.background_image = background_image
  }
}
